/* eslint max-len: 0 */

import React from 'react';
import { useRegisterContext } from 'pages';
import { Services } from 'services';
import { captureEventV2 } from 'utils/events/captureEvent';
import { Events } from '@clariness/tracking-event-runtime';
import { useUserAgreement } from './useUserAgreement';
import { UserAgreementView } from './UserAgreementView';

export const RegisterUserAgreement = () => {
  const { token, email, password } = useRegisterContext();
  const { login } = Services.Auth.useLogin();

  const { finishRegistration, isLoading } =
    Services.SiteEmployees.useFinishRegistration({
      onSuccess: (data) => {
        captureEventV2(
          Events.InvestigatorService.InvestigatorInvitationAccepted({
            InvestigatorID: data?.id ?? '',
          })
        );
        login(email, password);
      },
      onError: () => resetAgreement(),
    });

  const {
    hasAgreedToAgreement,
    shouldShowPromptMessage,
    onScrollBottomOfAgreement,
    onCheckboxChange,
    resetAgreement,
  } = useUserAgreement(() => finishRegistration({ token, email, password }));

  return (
    <UserAgreementView
      isLoading={isLoading}
      hasAgreed={hasAgreedToAgreement}
      shouldShowPrompt={shouldShowPromptMessage}
      onScrollBottom={onScrollBottomOfAgreement}
      onCheckboxChange={onCheckboxChange}
    />
  );
};
